module.exports = __webpack_public_path__ + "static/media/CBOD.44b6842c.svg";